import { Typography } from '@mui/material'
import React from 'react'
import { keyframes } from 'tss-react'
import { makeStyles } from 'tss-react/mui'

export interface ILandingHeaderTitleProps {
  children: React.ReactNode
}

const useStyles = makeStyles()(theme => ({
  title: {
    color: '#FFF',
    textAlign: 'center',
    margin: theme.spacing(2, 2),
    animation: `${keyframes`
      from {
        opacity: 0,
        transform: scale(0),
      }
      to {
        opacity: 1,
        transform: scale(1),
      }
    `} 0.6s cubic-bezier(1, 0, 0, 1)`,
    transformOrigin: 'center top',
    [theme.breakpoints.down('md')]: {
      margin: theme.spacing(1, 2),
    },
  },
}))

function LandingHeaderTitle(props: ILandingHeaderTitleProps) {
  const { children } = props
  const { classes } = useStyles()

  return (
    <Typography className={classes.title} variant="h1">
      {children}
    </Typography>
  )
}

export default React.memo(LandingHeaderTitle)
